import { z } from 'zod';

export const createQuoteRequestSchema = z.object({
  itemId: z.string().uuid(),
  vendorName: z.string().max(255).optional(),
  vendorId: z.string().uuid().optional(),
  vendorContactId: z.string().uuid().optional(),
  sentAt: z.string().datetime().optional(),
  notes: z.string().max(2000).nullable().optional(),
}).refine(d => d.vendorName || d.vendorId, { message: 'vendorName or vendorId is required' });

// vendorId / vendorContactId are intentionally omitted — a quote request is
// addressed to a specific vendor at send time; changing the recipient after
// the fact would lose the audit trail. Re-create the request instead.
export const updateQuoteRequestSchema = z.object({
  vendorName: z.string().min(1).max(255).optional(),
  sentAt: z.string().datetime().optional(),
  status: z.enum(['pending', 'received', 'no_response']).optional(),
  notes: z.string().max(2000).nullable().optional(),
});

export type CreateQuoteRequestInput = z.input<typeof createQuoteRequestSchema>;
export type UpdateQuoteRequestInput = z.input<typeof updateQuoteRequestSchema>;
